import { ceil1dec, floor1dec, round1dec } from '../../../../../includes/assets/js/modules/dpitUtilsInc';
import { getCssValFloat } from '../dpitUtilsPublic';
import DpitBB from './DpitBB';


const calculateSpaceAroundFeature = (tooltipBB, maxScreenBB, isLeftOrRight) => {
	// Calculate features
	let spaceAroundRatio = {
		width: tooltipBB.width / maxScreenBB.width,
		height: tooltipBB.height / maxScreenBB.height
	};
	return isLeftOrRight ? spaceAroundRatio.width - spaceAroundRatio.height : spaceAroundRatio.height - spaceAroundRatio.width;
};

const determineGoldenIncrement = (spaceAroundFeature, isOverHeight, isLeftOrRight, maxDocBB, tooltipBB, closerToTargetBB, tooltipPos) => {
	let moveCloserToWinBorder = Math.sign(spaceAroundFeature) < 0;

	if (isOverHeight) moveCloserToWinBorder = isLeftOrRight;
	let range = [0, 0];
	switch (tooltipPos.base) {
		case 'left': range = moveCloserToWinBorder ? [maxDocBB.left, tooltipBB.left] : [tooltipBB.left, closerToTargetBB.left]; break;
		case 'right': range = moveCloserToWinBorder ? [tooltipBB.right, maxDocBB.right] : [closerToTargetBB.right, tooltipBB.right]; break;
		case 'top': range = moveCloserToWinBorder ? [maxDocBB.top, tooltipBB.top] : [tooltipBB.top, closerToTargetBB.top]; break;
		case 'bottom': range = moveCloserToWinBorder ? [tooltipBB.bottom, maxDocBB.bottom] : [closerToTargetBB.bottom, tooltipBB.bottom]; break;
	}
	return Math.floor((moveCloserToWinBorder ? -1 : 1) * (range[1] - range[0]) / 2);
};

const modifyTooltipPosition = (increment, targetBB, tooltipEl, tooltipBB, tooltipPos, isLeftOrRight, tooltipMinWidth) => {
	if (isLeftOrRight) {
		if (tooltipBB.width - increment < tooltipMinWidth) return false;
		const bkpTooltipBB = { ...tooltipBB };

		tooltipEl.style.width = round1dec(tooltipBB.width - increment) + 'px';

		if (tooltipPos.base === 'left') {

			const newWidth = $(tooltipEl).outerWidth(false);
			if (newWidth !== bkpTooltipBB.width) {
				tooltipEl.style.left = ceil1dec(tooltipBB.left - (newWidth - bkpTooltipBB.width) - targetBB.left) + 'px';
			}
		}
		switch (tooltipPos.align) {
			case 'middle': {
				const newHeight = $(tooltipEl).outerHeight(false);
				if (newHeight !== bkpTooltipBB.height) {
					tooltipEl.style.top = floor1dec((targetBB.height - newHeight) / 2) + 'px';
				}
				break;
			}
			case 'bottom': {
				const newHeight = $(tooltipEl).outerHeight(false);
				if (newHeight !== bkpTooltipBB.height) {
					tooltipEl.style.top = floor1dec(tooltipBB.bottom - newHeight + 1 - targetBB.top) + 'px';
				}
				break;
			}
		}

	}
	else {
		// adjusting height doesn't automatically change a width ... so changing width instead
		if (tooltipBB.width + increment < tooltipMinWidth) return false;
		const bkpTooltipHeight = tooltipBB.height;
		const bkpTooltipWidth = tooltipBB.width;
		const currentLeft = getCssValFloat(tooltipEl, 'left', 0);
		tooltipEl.style.width = round1dec(tooltipBB.width + increment) + 'px';
		const newWidth = $(tooltipEl).outerWidth(false);
		const appliedIncrement = newWidth - bkpTooltipWidth;
		if (bkpTooltipWidth !== newWidth) {
			if (tooltipPos.align === 'center') {
				tooltipEl.style.left = round1dec(currentLeft - (appliedIncrement / 2)) + 'px';
			}
			else if (tooltipPos.align === 'right') {
				tooltipEl.style.left = round1dec(tooltipBB.left - appliedIncrement - targetBB.left) + 'px';
			}
		}

		if (tooltipPos.base === 'top') {
			const newHeight = $(tooltipEl).outerHeight(false);
			if (newHeight !== bkpTooltipHeight) {
				tooltipEl.style.top = floor1dec(tooltipBB.top - (newHeight - bkpTooltipHeight) - targetBB.top) + 'px';
			}
		}

	}
	return true;
};


const returnResult = (isOverHeight, wasPosAdjusted, iterations, dpDebugEn, dbgFailedReason) => {
	if (dpDebugEn) {
		if (wasPosAdjusted) {
			console.log('[dpit] GOLDEN RATIO:', `success (by ${iterations} iterations)`);
		}
		else {
			console.log(`[dpit] GOLDEN RATIO: ${dbgFailedReason}`, `iterations: ${iterations}`);
		}
	}
	return {
		wasPosAdjusted,
		isOverHeight
	};
};


const revertLastModificationAndReturn = (lastTooltipInlineStyle, tooltipEl, lastIsOverHeight, iterations, dpDebugEn, dbgFailedReason) => {
	tooltipEl.setAttribute('style', lastTooltipInlineStyle);
	iterations--;
	return returnResult(lastIsOverHeight, iterations > 0, iterations, dpDebugEn, dbgFailedReason);
};

const getInlineStyleOfElement = (tooltipEl) => {
	let inlineStyle = tooltipEl.getAttribute('style');
	if (inlineStyle === null) return false;
	if (typeof inlineStyle === 'object') inlineStyle = inlineStyle.cssText;
	return inlineStyle;
};


export default (targetBB, initTooltipBB, tooltipEl, tooltipPos, maxWinBB, maxDocBB, isFixedPos, tooltipMinWidth, dpDebugEn, maxIterations = 10) => {
	const initIsOverHeight = initTooltipBB.height > maxWinBB.height;
	const isLeftOrRight = ['left', 'right'].includes(tooltipPos.base);

	let iterations = 0;

	let lastTooltipInlineStyle = getInlineStyleOfElement(tooltipEl);


	let tooltipBB = { ...initTooltipBB };
	let lastTooltipBB = null;
	let isOverHeight = initIsOverHeight;
	let lastIsOverHeight = null;
	let lastFeatureSpaceAround = null;

	// Calculate the space around feature
	let featureSpaceAround = calculateSpaceAroundFeature(tooltipBB, maxWinBB, isLeftOrRight);

	while (iterations < maxIterations) {

		// Was algorithm successful so finish ?
		let isBestPosFound = false;
		if (!isOverHeight) {
			if (lastFeatureSpaceAround) {
				const featureSpaceAroundDerivation = Math.abs(lastFeatureSpaceAround) - Math.abs(featureSpaceAround);
				isBestPosFound = Math.abs(featureSpaceAround) <= 0.1 || featureSpaceAroundDerivation <= 0.05;
			} else {
				isBestPosFound = Math.abs(featureSpaceAround) <= 0.03;
			}
		}
		if (isBestPosFound) return returnResult(isOverHeight, iterations > 0, iterations, dpDebugEn, 'was not needed');

		// Determine size/position increment by golden ratio
		const increment = determineGoldenIncrement(
			featureSpaceAround,
			isOverHeight,
			isLeftOrRight,
			maxDocBB,
			tooltipBB,
			iterations === 0 ? targetBB : tooltipBB,
			tooltipPos
		);

		iterations++;
		let wasPositionChange = false;
		// Change to new size/position
		if (increment && modifyTooltipPosition(
			increment,
			targetBB,
			tooltipEl,
			tooltipBB,
			tooltipPos,
			isLeftOrRight,
			tooltipMinWidth,
			isFixedPos
		)) {
			tooltipBB = DpitBB.fromElement(tooltipEl, isFixedPos);
			const maxArea = maxWinBB;// isFixedPos ? maxWinBB : maxDocBB;
			if (tooltipBB && tooltipBB.left >= maxArea.left - 1 && tooltipBB.right <= maxArea.right + 1) {
				wasPositionChange = true;
			} else {
				return revertLastModificationAndReturn(
					lastTooltipInlineStyle,
					tooltipEl,
					lastIsOverHeight ?? initIsOverHeight,
					iterations,
					dpDebugEn,
					'out of win'
				);
			}
		}


		if (!wasPositionChange || (lastTooltipBB && DpitBB.isEqual(lastTooltipBB, tooltipBB))) {
			return revertLastModificationAndReturn(
				lastTooltipInlineStyle,
				tooltipEl,
				lastIsOverHeight ?? initIsOverHeight,
				iterations,
				dpDebugEn,
				'no effect'
			);
		}
		// Check over height
		isOverHeight = tooltipBB.height > maxWinBB.height;
		lastFeatureSpaceAround = featureSpaceAround;
		featureSpaceAround = calculateSpaceAroundFeature(tooltipBB, maxWinBB, isLeftOrRight);
		// Check not a beneficial golden iteration direction
		if (lastFeatureSpaceAround && !isOverHeight && Math.abs(featureSpaceAround) > Math.abs(lastFeatureSpaceAround)) {
			return revertLastModificationAndReturn(
				lastTooltipInlineStyle,
				tooltipEl,
				lastIsOverHeight ?? initIsOverHeight,
				iterations,
				dpDebugEn,
				'worse feature'
			);
		}

		lastTooltipInlineStyle = getInlineStyleOfElement(tooltipEl);
		lastTooltipBB = { ...tooltipBB };
		lastIsOverHeight = isOverHeight;
	}
	return returnResult(initIsOverHeight, false, iterations, dpDebugEn, 'too many iterations');
};